import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 480px;

  &.border {
    border: 1px solid ${props => props.theme.secondaryColorLight};
    border-radius: 0 0 4px 4px;
    border-top: none;
  }

  ${props => props.theme.isMobile && `
    height: 360px;
  `};
`;

const Img = styled.img`
  height: 96px;
  width: 96px;
`;

const Header = styled.h2`
  font-size: 24px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  margin-bottom: 16px;
`;

const Message = styled.p`
  font-size: 18;
  text-align: center;
  margin: 0;
`;

export default function Success({ organization, border }) {
  const message = `Your enquiry has been sent to ${organization}`;

  return (
    <Container className={border ? 'border' : ''}>
      <Img src={window.getLivewireAssetPath('success-icon.svg')} alt="Success" />
      <Header>Success</Header>
      <Message>{message}</Message>
    </Container>
  );
}

Success.propTypes = {
  organization: PropTypes.string.isRequired,
  border: PropTypes.bool,
};

Success.defaultProps = {
  border: false,
};
